// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1C6mG","col":"styles_col__10wQb"};